var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmbulance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 128 128",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M110.68 68.178 99.877 43.877A20.018 20.018 0 0 0 81.602 32H64v-4c0-6.617-5.383-12-12-12s-12 5.383-12 12v4H8c-4.412 0-8 3.588-8 8v68c0 4.412 3.588 8 8 8h8.568c1.789 6.881 7.999 12 15.432 12s13.643-5.119 15.432-12h33.136c1.789 6.881 7.999 12 15.432 12s13.643-5.119 15.432-12H120c4.412 0 8-3.588 8-8V88c0-10.119-7.555-18.508-17.32-19.822zM92.568 47.127 101.846 68H84c-2.205 0-4-1.795-4-4V40h1.602c4.736 0 9.041 2.797 10.966 7.127zM48 28c0-2.205 1.795-4 4-4s4 1.795 4 4v4h-8zm24 12v24c0 6.617 5.383 12 12 12h24c5.208 0 9.606 3.354 11.263 8H8V40zm-40 80c-4.412 0-8-3.588-8-8s3.588-8 8-8 8 3.588 8 8-3.588 8-8 8zm64 0c-4.412 0-8-3.588-8-8s3.588-8 8-8 8 3.588 8 8-3.588 8-8 8zm15.432-12c-1.789-6.881-7.999-12-15.432-12s-13.643 5.119-15.432 12H47.432C45.643 101.119 39.433 96 32 96s-13.643 5.119-15.432 12H8V92h112v16zM24 64a4 4 0 0 1 4-4h8v-8a4 4 0 0 1 8 0v8h8a4 4 0 0 1 0 8h-8v8a4 4 0 0 1-8 0v-8h-8a4 4 0 0 1-4-4zm41.172-45.172a3.997 3.997 0 0 1 0-5.656l4-4c1.563-1.563 4.094-1.563 5.656 0s1.563 4.094 0 5.656l-4 4C70.047 19.609 69.023 20 68 20s-2.047-.391-2.828-1.172zM48 8V4a4 4 0 0 1 8 0v4a4 4 0 0 1-8 0zm-18.828 6.828c-1.563-1.563-1.563-4.094 0-5.656s4.094-1.563 5.656 0l4 4a3.997 3.997 0 0 1 0 5.656C38.047 19.609 37.023 20 36 20s-2.047-.391-2.828-1.172z",
    fill: "#7f56d9",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmbulance);
export default __webpack_public_path__ + "static/media/ambulance.c97610caa3054ba0dca6f03ad461ae53.svg";
export { ForwardRef as ReactComponent };